import Contacts from "./contacts.js";
import LightboxOverlay from "./lightbox-overlay.js";
import NavMenu from "./nav-menu.js";
import ProductDetail from "./product-detail.js";
import ProductsGrid from "./products-grid.js";
import PostsGrid from "./posts-grid.js";
import TopHeader from "./top-header.js";

export default {
  Contacts,
  LightboxOverlay,
  NavMenu,
  ProductDetail,
  PostsGrid,
  ProductsGrid,
  TopHeader
}